<div class="container u-mt60">
  <div class="row">
      <div class="col-12">
          <div class="breadcrumbs">
              <ul>
                  <li>
                      <a routerLink="/dashboard">
                          Inicio
                      </a>
                  </li>
              </ul>
          </div>
      </div>
      <div class="col-md-7 u-mb50">
          <h1 class="txt txt--title">
              Aprobación de solicitudes
          </h1>
      </div>
      <div class="col-md-5">
          <div class="u-desktop">
              <div class="form autocomplete autocomplete--small">
                  <input type="text" id="iexample" class="form__search" placeholder="Buscar" [(ngModel)]="searchText" >
              </div>
          </div>
      </div>
      <div class="col-md-12 border-b">
        <div class="table table--history">
            <div class="thead thead--orange">
                <div class="tr">
                    <!--begin head sorting -->
                    <div class="th global-hand" [class.active]="order === 'asset'" (click)="setOrder('asset')">
                      <div class="table-head header-table">
                       <p>Asset</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'asset' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'asset' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="th" [class.active]="order === 'requirementType.name'" (click)="setOrder('requirementType.name')">
                      <div class="table-head header-table">
                        <p>Tipo solicitud</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'requirementType.name' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'requirementType.name' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'requirementType.name' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'requirementType.name' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="th" [class.active]="order === 'requirementId'" (click)="setOrder('requirementId')">
                       <div class="table-head header-table">
                         <p>Nº solicitud</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'requirementId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'requirementId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'requirementId' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'requirementId' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="th" [class.active]="order === 'requestorName'" (click)="setOrder('requestorName')">
                      <div class="table-head header-table">
                        <p>Solicitante</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'requestorName' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'requestorName' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'requestorName' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'requestorName' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="th" [class.active]="order === 'date'" (click)="setOrder('date')">
                      <div class="table-head header-table">
                       <p>Fecha solicitud</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'date' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'date' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'date' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'date' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="shouldShowDelegatorNameColumn" class="th" [class.active]="order === 'delegatorName'" (click)="setOrder('delegatorName')">
                      <div class="table-head header-table">
                       <p>Delegada por</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'delegatorName' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'delegatorName' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'delegatorName' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'delegatorName' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="shouldShowAssignedColumn" class="th" [class.active]="order === 'assignedName'" (click)="setOrder('assignedName')">
                      <div class="table-head header-table">
                       <p>Asignada a</p>
                        <div class="sorting-arrows-container">
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'assignedName' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting ASC -->
                            <div [hidden]="(order === 'assignedName' && orderStatus === 2)"
                              style="height: 11px; max-height: 11px;">
                              <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                          <div class="arrow-container">
                            <!-- Sorting Disabled -->
                            <div [hidden]="!(order === 'assignedName' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                            </div>
                            <!-- Sorting DESC -->
                            <div [hidden]="(order === 'assignedName' && orderStatus === 3)">
                              <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="th">
                      <div class="table-head header-table">Detalle</div>
                    </div>

                  <!-- end head sorting -->
                </div>
            </div>
            <div class="tbody desktop">
              <ng-container *ngFor="let approval of listRequestApprovalApi  | filterTable:  searchText  | orderBy: order :reverse : true | paginate : config">
                <div
                  class="tr enabled-row"
                >
                    <div class="td td--number">
                        <p>{{approval.asset}}</p>
                    </div>
                    <div class="td td--button">
                        <p>{{approval.requirementType.name}}</p>
                    </div>
                    <div class="td td--status">
                        <p><span class="mr-2">Nº Solicitud:</span>{{approval.requirementId}}</p>
                    </div>
                    <div class="td td--body">
                        <p><span>Solicitante </span> {{approval.requestorName}}</p>
                    </div>
                    <div class="td td--body">
                        <p><span>Fecha solicitud: </span>{{approval.date |date :"dd/MM/YYYY"}} - {{approval.remainingDays === 0 ? 'Hoy' : approval.remainingDays + ' días'}} </p>
                    </div>
                    <div class="td td--body" *ngIf="shouldShowDelegatorNameColumn">
                        <p><span>Delegada por: </span>{{approval.delegatorName}}</p>
                    </div>
                    <div class="td td--body" *ngIf="shouldShowAssignedColumn">
                        <p><span>Asignada a: </span>{{approval.assignedName}}</p>
                    </div>
                    <div class="td td--body">
                        <a
                          class="btn btn--link btn--link--secondary"
                         (click)="goToApproval(approval.requirementId, approval.requirementType.id)"
                        >Revisar</a>
                    </div>
                </div>
              </ng-container>

            </div>
            <div class="tbody mobile">
                <mat-accordion>

                    <div   *ngFor="let approval of listRequestApprovalApi  | filterTable:  searchText  | orderBy: order :reverse : true | paginate : config">
                     <mat-expansion-panel class="tableRowsResponsive" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                       <mat-expansion-panel-header >
                     <mat-panel-title class="assetName">
                       <div class="containerP"><p>{{approval.asset}}</p></div>
                       </mat-panel-title>
                     <mat-panel-description class="descriptionAct">
                     <p>{{approval.approvalType}}</p>
                     <p class="subTitle"><span>Número de solicitud:</span>{{approval.requirementId}}</p>


                     </mat-panel-description>
                     </mat-expansion-panel-header>
                      <div class="bodyDetail">
                        <p><span>Solicitante:</span>{{approval.nameApprovalReques}}</p>
                     <p ><span class="mr-2">Fecha:</span>{{approval.dateApprovalRequest |date: "dd/MM/YYYY"}} - {{approval.remainingDays}} días </p>
                     <p *ngIf="shouldShowDelegatorNameColumn"><span>Delegada por:</span>{{approval.nameDelegate}}</p>
                     <p *ngIf="shouldShowAssignedColumn"><span>Asignada a:</span>{{approval.assignedName}}</p>
                     <p>
                       <a
                        class="textMoreInformationMobile"
                        (click)="goToApproval(approval.requirementId, approval.requirementType.id)"
                       >Revisar</a>
                      </p>
                      </div>

                   </mat-expansion-panel>
           </div>

         </mat-accordion>
            </div>
        </div>
        <!-- Loading -->
        <div *ngIf="gettingList && listRequestApprovalApi.length === 0"
        style="width: 100%; min-width: 100%; height: 60px; min-height: 60px; margin: 10px;">
        <app-loader></app-loader>
      </div>

      <!-- Loaded but no rows -->
      <div *ngIf="!gettingList && listRequestApprovalApi.length === 0"
        style="width: 100%; min-width: 100%; height: 60px; min-height: 60px; margin: 10px; text-align: center">
        No tiene Aprobaciones pendientes
      </div>
        <div class="u-right u-mt20 u-mb20">
            <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="config.currentPage = $event">
                <div class="custom-pagination">
                  <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
                    <span *ngIf="!p.isFirstPage()" (click)="p.previous()"> < </span>
                    </div>
                    <div class="page-number" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                          <span (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</span>
                        <div *ngIf="p.getCurrent() === page.value">
                          <span>{{ page.label }}</span>
                        </div>
                    </div>
                    <div class="pagination-next" [class.disabled]="p.isLastPage()">
                      <span *ngIf="!p.isLastPage()" (click)="p.next()"> > </span>
                    </div>
                </div>

              </pagination-template>
        </div>
      </div>
      <div class="col-12 u-mt30 margin-text-link-delegation">
          <h6 class="txt txt--paragraph">Si no estarás disponible para revisar las solicitudes pendientes puedes <a  class="txt txt--paragraph" routerLink="/delegate"> delegar la función a otra persona de tu área.</a></h6>
      </div>
  </div>
</div>
